import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';

type ProgressButtonProps = {
    onClick?: (event: React.FormEvent) => void;
    navRoute: string;
    text: string;
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    locationState?: any;
    buttonStyle?: string;
};

const ProgressButton = memo(ProgressButtonMemo, (prevProps, currentProps) => {
    return (
        prevProps.buttonStyle === currentProps.buttonStyle &&
        prevProps.locationState === currentProps.locationState
    );
});

function ProgressButtonMemo({
    onClick,
    navRoute,
    text,
    locationState = {},
    buttonStyle
}: ProgressButtonProps) {
    return (
        <NavLink
            onClick={onClick}
            to={navRoute}
            state={locationState}
            className={buttonStyle}>
            {text}
        </NavLink>
    );
}

export default ProgressButton;
